/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { departmentsControllerCreate } from "./departmentsControllerCreate";
import { departmentsControllerFindAll } from "./departmentsControllerFindAll";
import { departmentsControllerFindOne } from "./departmentsControllerFindOne";
import { departmentsControllerRemove } from "./departmentsControllerRemove";
import { departmentsControllerUpdate } from "./departmentsControllerUpdate";

export function departmentsService() {
  return { departmentsControllerCreate, departmentsControllerFindAll, departmentsControllerFindOne, departmentsControllerUpdate, departmentsControllerRemove }
}